import React from 'react';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { selectIsGlobalLoading, selectLoadingMessage } from '../../store/selectors/uiSelectors';

interface GlobalLoaderProps {
  isLoading?: boolean;
  message?: string;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ isLoading: propsIsLoading, message: propsMessage }) => {
  const reduxIsLoading = useSelector(selectIsGlobalLoading);
  const reduxMessage = useSelector(selectLoadingMessage);

  const isLoading = propsIsLoading !== undefined ? propsIsLoading : reduxIsLoading;
  const message = propsMessage !== undefined ? propsMessage : reduxMessage;

  if (!isLoading) {
    return null;
  }

  return <LoadingSpinner overlay size="large" message={message || undefined} />;
};

export default GlobalLoader;
